import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from './ui/card';
import { H3, P } from './ui/typography';

export function PageHeader({ title, description, children }) {
  return (
    <Card className="mb-6 border-0 shadow-none">
      <CardContent className="p-0">
        <div className="flex justify-between items-center">
          <div>
            <H3 className="text-[#475569]">
              {title}
            </H3>
            {description && (
              <P className="text-[#94A3B8] mt-0">
                {description}
              </P>
            )}
          </div>
          {children}
        </div>
      </CardContent>
    </Card>
  );
}

export function AnimatedCard({ children, className = '' }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Card className={className}>
        <CardContent className="p-6">
          {children}
        </CardContent>
      </Card>
    </motion.div>
  );
}

export function DataList({ items }) {
  return (
    <dl className="grid grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-2">
      {items.map(([label, value]) => (
        <div key={label} className="border-b border-gray-200 pb-4">
          <dt className="text-sm font-medium text-gray-500">{label}</dt>
          <dd className="mt-1 text-sm text-gray-900">{value || '-'}</dd>
        </div>
      ))}
    </dl>
  );
}

export function LoadingSpinner() {
  return (
    <div className="flex justify-center items-center p-8">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
    </div>
  );
}

export function EmptyState({ title, description, icon, action }) {
  return (
    <div className="text-center py-12">
      <div className="flex justify-center mb-4">
        <span className="text-4xl">{icon}</span>
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">
        {title}
      </h3>
      <p className="text-sm text-gray-600 mb-4">
        {description}
      </p>
      {action}
    </div>
  );
}
